import { PublishedWork } from '@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/published_work_pb';

export function canEditPublishedWork(publishedWork: PublishedWork): boolean {
  return (
    publishedWork.creatorUserId.length > 0 &&
    (publishedWork.externalSource == null || publishedWork.canExternalSourceBeUpdated)
  );
}
